import React, { useState, useEffect } from 'react';
import { motion, useReducedMotion } from 'framer-motion';

const RakshanPreloader = ({ onComplete }) => {
  const [progress, setProgress] = useState(0);
  const reduceMotion = useReducedMotion();

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(timer);
          setTimeout(() => onComplete(), 200);
          return 100;
        }
        return prev + Math.random() * 20;
      });
    }, 80);

    return () => clearInterval(timer);
  }, [onComplete]);

  return (
    <motion.div
      className="fixed inset-0 bg-[var(--bg-canvas)] text-[var(--fg-primary)] flex items-center justify-center z-50 overflow-hidden"
      initial={{ opacity: 1 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0, transition: { duration: 0.3 } }}
    >
      <div className="text-center z-10 relative max-w-sm w-full px-6">
        {/* Name Header */}
        <div className="mb-8">
          <h1 className="text-2xl font-semibold tracking-[0.12em] uppercase mb-1 text-[var(--fg-primary)]">
            RAKSHAN SHETTY
          </h1>
          <p className="text-xs font-eyebrow text-[var(--fg-secondary)]">
            Portfolio
          </p>
        </div>

        {/* Progress Bar */}
        <div className="w-full mb-4">
          <div className="h-1 bg-[var(--bg-recessed)] rounded-full overflow-hidden shadow-[var(--border-ring)]">
            <motion.div
              className="h-full bg-[var(--fg-primary)] rounded-full"
              initial={{ width: '0%' }}
              animate={{ width: `${progress}%` }}
              transition={{ duration: reduceMotion ? 0 : 0.2 }}
            />
          </div>
          <div className="text-[var(--fg-secondary)] text-xs mt-2 font-mono text-center">
            {Math.round(progress)}%
          </div>
        </div>

        <p className="text-xs text-[var(--fg-muted)] font-mono">Loading</p>
      </div>
    </motion.div>
  );
};

export default RakshanPreloader;